

$(document).ready(function() {
    // permet de connaitre le numéro de question
    let numeroQuestion = 0;
    // permet de connaitre le destinataire
    let destinataire = "";
    // permet de garder le 1er destinataire
    let destinataireDefaut = "";
    // on récupère l'id du formulaire
    let uniqId =  $('.quizz').data('uniq-id');
    // on récupère les questions et leurs reponse
    let questions = $('.quizz').data('questions');


    // On affiche la première question
    affichageQuestion(questions[0]);
    
    $(document).on('click','#button1,#button2',function() {
        // On garde la valeur destinateire de la premiere question
        if (questions[numeroQuestion]['id'] === 1) {
            destinataireDefaut = this.value;
        } 

        // On garde le même destinataire si la valeur est vide
        if (this.value != "") {
            destinataire = this.value;
        } else {
            destinataire = destinataireDefaut;
        }
            
        // On verifie la presence d'une question
        if (questions[numeroQuestion]) {
            // on rempli le champ du formulaire
            implementationFormulaire(questions[numeroQuestion]['class_champ'], $(this).html());
            // on choisi le destinataire
            choixDestinataire(destinataire);
        }
        
        
        // on passe à la question suivante
        numeroQuestion++;

        // On verifie la presence d'une question
        if (questions[numeroQuestion]) {
            // on affiche la question suivante
            affichageQuestion(questions[numeroQuestion]);
            // on affiche le bouton retour
            affichageBoutonRetour(numeroQuestion);
        } else {
            // On cache le label du champ destinataire
            $(".destinataire").parent().children('label').attr("hidden",true);
            // on affiche le formulaire
            affichageFormulaire(uniqId) 
        }
            
    });

    $(document).on('click','#boutonRetour',function() { 

        if (numeroQuestion > 0) {
            // on revient à la question precedente
            numeroQuestion--;
            // on cache le bouton retour si besoins
            affichageBoutonRetour(numeroQuestion)
        }

        // On verifie la presence d'une question
        if (questions[numeroQuestion]) {
            // on affiche la question suivante
            affichageQuestion(questions[numeroQuestion]);
        }
       
    });

    $(document).on('click','#boutonRetourQuestion',function() {
        numeroQuestion--;
        affichageQuizz(uniqId);
    });

    // Permet de cacher le bouton retour quand on execute le formulaire.
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === "class") {
            $('#boutonRetourQuestion').attr("hidden",true);
          }
        });
      });
      observer.observe($('#formulaire_message_'+uniqId)[0], {
        attributes: true
      });
    


    /**
     * Permet d'afficher un question
     * @param {*} question 
     */
    function affichageQuestion(question) {
        $('.quizz-questions').children('span').text(question.question);
        $('#button1').text(question.reponse1.phrase);
        $('#button1').val(question.reponse1.value);
        $('#button2').text(question.reponse2.phrase);
        $('#button2').val(question.reponse2.value);

    }
    /**
     * Permet de cacher le quizz et d'afficher le formulaire
     * @param {*} uniqId 
     */
    function affichageFormulaire(uniqId) {
        // On cache le quizz et on affiche le formulaire
        $('#formulaire_container_' + uniqId).removeAttr('hidden');
        $('.quizz-questions').attr("hidden",true);
        $('#boutonRetourQuestion').removeAttr('hidden');   
    }

     /**
     * Permet de cacher le formulaire et d'afficher le quizz
     * @param {*} uniqId 
     */
      function affichageQuizz(uniqId) {
        // On cache le formulaire et on affiche le quizz
        $('#formulaire_container_' + uniqId).attr("hidden",true);
        $('.quizz-questions').removeAttr('hidden');
        $('#boutonRetourQuestion').attr("hidden",true);   
    }

    /**
     * Permet de remplir le champ .destinataire dans le formulaire
     * @param {*} destinataire 
     */
    function choixDestinataire(destinataire) {
        // on ajoute selected au choix de destinataire
        $(".destinataire").children().filter(function() {
            return $(this).text() === destinataire;
        }).prop('selected', true);
    }

    /**
     * Permet de remplir un champ du formulaire
     * @param {*} classChamp 
     * @param {*} resultat 
     */
    function implementationFormulaire(classChamp, resultat) {
        $('.'+classChamp).val(resultat)
    }

    /**
     * Permet de d'afficher le bouton retour
     * @param {*} numeroQuestion 
     */
    function affichageBoutonRetour(numeroQuestion) {
        // On affiche le bouton retour sauf première question
        if (numeroQuestion <= 0) {
            $('#boutonRetour').attr("hidden",true);
        } else {
            $('#boutonRetour').removeAttr('hidden');
        }
    }

        


});




